<!--
 * @Author: ZS
 * @Date: 2020-06-23 11:46:25
 * @LastEditors: ZS
 * @LastEditTime: 2020-07-17 17:34:14
 * @Description: file content
-->
<!--
 * @Author: ZS
 * @Date: 2020-06-18 16:24:41
 * @LastEditors: ZS
 * @LastEditTime: 2020-06-23 10:01:30
 * @Description: file content
-->
<template>
  <div class="myBusiness">
    <div class="search_wrap">
      <template v-for="(item, index) in searchList">
        <div
          class="search_item"
          :key="index"
        >
          <span class="left">{{item.label}}</span>
          <span class="right">
            <template v-if="item.field === 'text'">
              <el-input
                v-model="searchData[item.code]"
                placeholder="请输入内容"
                size="medium"
                clearable
                v-blurTrim
              ></el-input>
            </template>
            <template v-if="item.field === 'date-range'">
              <el-date-picker
                v-model="searchData[item.code[0]]"
                placeholder="请选择"
                value-format="yyyy-MM-dd"
                clearable
                size="medium"
                style="width: 140px;"
              ></el-date-picker>
              <span class="connection">至</span>
              <el-date-picker
                v-model="searchData[item.code[1]]"
                placeholder="请选择"
                value-format="yyyy-MM-dd"
                clearable
                size="medium"
                style="width: 140px;"
              ></el-date-picker>
            </template>
          </span>
        </div>
      </template>
      <div class="search_item btn_item">
        <el-button
          type="primary"
          size="medium"
          @click="searchFunc"
          class="search_btn"
        >搜索</el-button>
        <el-button
          size="medium"
          @click="resetFunc"
        >重置</el-button>
      </div>
    </div>
    <el-table
      :data="tableData"
      border
      style="width: 100%;"
    >
      <el-table-column
        prop="xuhao"
        width="60"
        label="序号"
        align="center"
      >
      </el-table-column>
      <el-table-column
        label="事项名称"
        prop="sxmc"
      >
        <template slot-scope="scope">
          <span>{{scope.row.sxmc}}</span>
          <div
            class="newBg"
            v-if="scope.row.hasNew"
          >新动态</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="pcHandlingGuidelineConsultationContent"
        label="咨询问题"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="pcHandlingGuidelineConsultationTime"
        label="发起时间"
        width="160"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="statu"
        label="回复状态"
        width="80"
        align="center"
      >
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row)"
            class="detailBtn"
          >详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div
      class="block fenyeBox"
      v-if="totalSize > 0"
    >
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalSize"
      >
      </el-pagination>
    </div>
    <!-- 详情对话框 -->
    <el-dialog
      title="咨询详情"
      :visible.sync="dialogVisible"
      width="550px"
      class="dialog"
    >
      <h3 class="sxName">咨询事项：{{sxName}}</h3>
      <div class="que clearfix">
        <span><img
            src="../../assets/images/que.png"
            style="margin-right:8px"
          >{{que}}</span>
        <p class="clearfix"><span class="pull-left">咨询人：{{zxr}}</span> <span class="pull-right">{{queTime}}</span></p>
      </div>
      <div class="ans clearfix">
        <span>回复：<el-input
            type="textarea"
            :rows="6"
            placeholder="请输入内容"
            v-model="ans"
            style="display:line-block;width: 87%; vertical-align: text-top;"
          >
          </el-input></span>
        <p>{{ansTime}}</p>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          @click="handleClose()"
          class="tjBtn"
          v-if="flag === 6"
        >提交回复</el-button>
        <el-button
          @click="handleClose()"
          class="tjBtn"
          v-if="flag === 5"
        >更新答案</el-button>
        <el-button @click="dialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import qs from "qs";
export default {
  props: {
    flag: {
      type: Number,
      default: 5
    }
  },
  data() {
    return {
      tableData: [],
      titIndex: 0,
      sfhf: 0,

      currentPage: 1,
      pageSize: 10,
      totalSize: 0,

      dialogVisible: false,
      que: "",
      queTime: "",
      ans: "",
      ansTime: "",
      zxr: "",
      id: "",
      code: "",
      sxName: "",
      // 查询条件
      searchData: {},
      oldSearchData: {}
    };
  },
  computed: {
    searchList() {
      return [
        { label: "事项名称", code: "guidelineName", field: "text" },
        {
          label: "发起时间",
          field: "date-range",
          code: ["startTime", "endTime"]
        }
      ];
    },
    initSearchData() {
      return {
        guidelineName: "",
        startTime: "",
        endTime: ""
      };
    }
  },
  watch: {
    flag(val) {
      if (val === 5) {
        this.sfhf = 1;
      } else {
        this.sfhf = 0;
      }
      this.searchData = {
        ...this.initSearchData
      };
      this.oldSearchData = {
        ...this.initSearchData
      };
      this.searchFunc();
    }
  },
  mounted() {
    this.searchData = {
      ...this.initSearchData
    };
    this.oldSearchData = {
      ...this.initSearchData
    };
    this.searchFunc();
  },
  methods: {
    /**
     * @name searchFunc
     * @description 查询方法
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-09-02 14:51:21
     */
    searchFunc() {
      const { startTime, endTime } = this.searchData;
      if (startTime && endTime && new Date(startTime) > new Date(endTime)) {
        // 如果两个时间都选择，且起始时间大于结束时间
        this.$message({
          type: "warning",
          message: "起始时间不能早于结束时间"
        });
        return;
      }
      this.oldSearchData = {
        ...this.searchData
      };
      this.handleCurrentChange(1);
    },
    /**
     * @name resetFunc
     * @description 重置方法
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-09-02 14:52:54
     */
    resetFunc() {
      this.searchData = {
        ...this.initSearchData
      };
      this.searchFunc();
    },
    handleEdit(index, row) {
      this.ans = "";
      if (this.sfhf != 0) {
        this.ans =
          row.portalPcHandlingGuidelineConsultationReply[0].pcHandlingGuidelineConsultationReplyContent;
        // this.ansTime = this.globalDateFormat({
        //   time:
        //     row.portalPcHandlingGuidelineConsultationReply[0]
        //       .pcHandlingGuidelineConsultationReplyTime,
        //   format: "yyyy-MM-dd hh:mm:ss"
        // });
        this.ansTime = row.portalPcHandlingGuidelineConsultationReply[0]
              .pcHandlingGuidelineConsultationReplyTime;
      }
      this.que = row.pcHandlingGuidelineConsultationContent;
      this.queTime = row.pcHandlingGuidelineConsultationTime;
      this.zxr = row.zxr;
      this.dialogVisible = true;
      this.id = row.pcHandlingGuidelineConsultationId;
      this.code = row.pcHandlingGuidelineConsultationGuidelineCode;
      this.sxName = row.sxmc;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getZx();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getZx();
    },
    titChange(idx) {
      this.titIndex = idx;
      this.sfhf = idx;
      this.ans = "";
      this.getZx();
    },
    // 获取我的咨询
    getZx() {
      if (this.flag === 5) {
        this.sfhf = 1;
      } else {
        this.sfhf = 0;
      }
      let sendData;
      sendData = qs.stringify({
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        type: this.sfhf,
        ...this.oldSearchData
      });
      this.ywtbRequest(
        "/portal-ywtb/web/consultation/findListConsultationByCondition",
        sendData
      ).then((res) => {
        var data = res.dataList;
        this.totalSize = res.count;
        for (let i = 0; i < data.length; i++) {
          data[i].xuhao = i + 1 + this.pageSize * (this.currentPage - 1);
          // data[
          //   i
          // ].pcHandlingGuidelineConsultationTime = this.publicJs.renderTime(
          //   data[i].pcHandlingGuidelineConsultationTime
          // );
          if (this.sfhf == 0) {
            data[i].statu = "未回复";
          } else {
            data[i].statu = "已回复";
          }
          if (data[i].pc_handling_guideline_consultation_checker == 0) {
            data[i].hasNew = true;
          }
        }
        this.tableData = res.dataList;
      });
    },
    //更改提交回复
    handleClose() {
      if (
        [undefined, null, ""].indexOf(this.ans) > -1 ||
        (this.ans.trim && this.ans.trim() === "")
      ) {
        this.$message({
          type: "warning",
          message: "回复内容不能为空"
        });
        return;
      }
      let sendData = qs.stringify({
        pcHandlingGuidelineConsultationReplyConsultationId: this.id,
        pcHandlingGuidelineConsultationReplyGuidelineCode: this.code,
        pcHandlingGuidelineConsultationReplyMemberId: this.$store.state.userId,
        pcHandlingGuidelineConsultationReplyContent: this.ans
      });
      this.ywtbRequest(
        "/portal-ywtb/web/consultation/saveConsultationByCondition",
        sendData
      ).then((res) => {
        this.$message({
          message: "操作成功",
          type: "success"
        });
        this.dialogVisible = false;
        this.getZx();
      });
    }
  }
};
</script>

<style scoped>
.myTit {
  /* line-height: 42px; */
  padding: 30px 0 15px 0;
  font-size: 16px;
  margin-bottom: 10px;
}

.myTit > span {
  float: left;
  color: #091b28;
  font-size: 22px;
  font-family: PingFang SC;
}

.myTit > ul {
  float: right;
}

.myTit > ul > li {
  float: left;
  width: 84px;
  height: 34px;
  background: rgba(53, 139, 247, 0.1);
  color: #687986;
  line-height: 34px;
  font-size: 16px;
  font-weight: normal;
  text-align: center;
  cursor: pointer;
}

.myTit > ul > li.active {
  background-color: #358bf7;
  color: #fff;
}

.detailBtn,
.advisoryBtn {
  width: 56px;
  height: 27px;
  border-radius: 14px;
  padding: 0;
  text-align: center;
  font-size: 13px;
  color: #fff;
  border: none;
}

.detailBtn {
  background: rgba(255, 165, 71, 1);
}

.detailBtn:hover,
.detailBtn:focus {
  background: rgba(255, 165, 71, 0.8);
  color: #fff;
}

.advisoryBtn {
  background: rgba(53, 139, 247, 1);
}

.advisoryBtn:hover,
.advisoryBtn:focus {
  background: rgba(53, 139, 247, 0.8);
  color: #fff;
}

.fenyeBox {
  text-align: center;
  padding-top: 20px;
}

.newBg {
  display: inline-block;
  width: 55px;
  height: 23px;
  line-height: 22px;
  background: url(../../../static/images/newBg.png) no-repeat 0px 0px;
  text-align: center;
  color: #fff;
  margin-left: 6px;
}

.que,
.ans {
  font-size: 16px;
  font-weight: 700;
  margin-top: 20px;
}

.que > p,
.ans > p {
  text-align: right;
  padding-right: 50px;
  font-size: 14px;
  color: #999;
  font-weight: normal;
  margin-top: 10px;
}
.que,
.ans {
  font-size: 16px;
  font-weight: 700;
  margin: 20px 0 20px 0;
}

.que > p,
.ans > p {
  text-align: right;
  font-size: 14px;
  color: #bfbfbf;
  font-weight: normal;
  line-height: 24px;
}
.dialog /deep/ .el-dialog__title {
  color: #262626;
  font-size: 18px;
  font-weight: 700;
}
.dialog /deep/ .el-textarea__inner {
  resize: none;
}
.dialog /deep/ .el-dialog__body {
  padding: 20px 40px 5px 20px;
}
.dialog /deep/ .el-dialog__footer {
  text-align: center;
  padding: 0px 0 30px 0;
}
.dialog /deep/ .el-button {
  border-radius: 2px;
}
.dialog .tjBtn {
  background: rgba(68, 110, 255, 1);
  color: #fff;
  border: none;
}
.dialog .tjBtn:hover {
  background: rgb(50, 93, 250);
}
.sxName {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #262626;
  padding-bottom: 10px;
  border-bottom: 1px solid #e8e8e8;
}
.replyPerson {
  color: #6a8bff;
  font-size: 14px;
  padding-left: 6px;
}
.noHf {
  text-align: center;
  padding: 10px 0 20px 0;
}
.noHf p {
  margin-top: 10px;
  color: #bfbfbf;
  font-size: 16px;
}
</style>
<style lang="scss" scoped>
@import "./common.scss";
</style>



// WEBPACK FOOTER //
// src/components/workbench/InquiryReply.vue